
<template>
  <div class="rightContent">
    <!-- 添加产品或服务介绍 -->
    <template v-if="companyTabIndex===4">
      <div class="header">
        <div class="title f_16 color_40 font_w_b">添加产品或服务介绍</div>
        <div class="tips f_12 color_60">产品指的公司研发的网站、手机应用、生成销售的硬件设备或服务</div>
      </div>
      <div class="products">
        <div class="addProduct f_14 color_blue text_center cursor_p" @click="addProduct">添加一个产品介绍</div>
        <div class="list">
          <div class="item flex cursor_p pr" v-for="(item,index) in company_data.products" :key="index" @click="editProduct(item,index)">
            <img :src="`${item.pro_logo}?x-oss-process=image/resize,w_200`" :alt="item.pro_name" >
            <div class="flex1">
              <div class="title f_14 color_40 font_w_b">{{item.pro_name}}</div>
              <div class="desc f_12 color_9c ellipsis2">{{item.pro_description}}</div>
            </div>
            <div class="iconfont iconGroup3 pa color_blue" @click.stop="productIndex=index;MessageBoxState=true"></div>
          </div>
        </div>
      </div>

      <!-- 编辑/添加产品弹窗 -->
      <div class="addProductBox" v-if="addProductState">
        <div class="content pa bg_fff">
          <div class="title f_18 color_40 font_w_b">编辑产品信息</div>
          <div class="dataForm">
            <div class="item flex" :class="[errorTips.pro_logo?'error':'']" >
              <div class="formTitle color_9c f_14 logoItem">*产品logo：</div>
              <div class="flex1">
                <div class="uploadBox">
                  <div class="upload pr">
                    <input type="file" class="avatar-uploader pa cursor_p" ref="fileUpload" accept="image/*" @change="fileUpload">
                    <img v-if="product.pro_logo" :src="`${product.pro_logo}?x-oss-process=image/resize,w_200`" class="logo pa">
                    <div class="uploadIcon text_center color_90 f_14" v-else>
                      <p class="iconfont iconupload"></p>
                      <p class="tipsName">上传图片</p>
                    </div>
                  </div>
                  <!-- 错误提示 -->
                  <div class="errorTipsDesc f_14" v-if="errorTips.pro_logo">
                    <span class="iconfont icontishi"></span>
                    <span class="tipsName">{{errorTips.pro_logo}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="item flex" :class="[errorTips.pro_name?'error':'']" >
              <div class="formTitle color_9c f_14">*产品名称：</div>
              <div class="flex1 pr">
                <el-input v-model="product.pro_name" placeholder="请输入产品名称" class="restInput f_14 color_40" :maxlength="20" @focus="inputFocus('pro_name')"></el-input>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.pro_name">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.pro_name}}</span>
                </div>
              </div>
            </div>
            <div class="item flex" :class="[errorTips.pro_description?'error':'']" >
              <div class="formTitle color_9c f_14">*产品描述：</div>
              <div class="flex1 description_hr pr">
                <el-input class="restInput textarea f_14 color_40"
                  type="textarea"
                  :rows="3"
                  :maxlength="100"
                  resize="horizontal"
                  placeholder="请简单介绍公司产品"
                  v-model="product.pro_description" @focus="inputFocus('pro_description')">
                </el-input>
                <div class="textLength pa f_14 color_60 bg_fff">{{product.pro_description.length}}/100</div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.pro_description">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.pro_description}}</span>
                </div>
              </div>

            </div>
          </div>
          <div class="templateButtons text_center clearfix">
            <div class="button confirmButton fr" @click="saveProduct"><span class="el-icon-loading" v-if="saveFormState"></span> 确定</div>
            <div class="button cancelButton fr" @click="toggleEditProductState(false);">取消</div>
          </div>

        </div>
      </div>
      <!-- 询问框 -->
      <MessageBox :pageData="MessageBoxData" v-if="MessageBoxState" @confirmButton="confirmButton" @cancelButton="cancelButton" />

    </template>
    
  </div>
</template>

<script>
  const oss = require('ali-oss');
  import { uuid } from 'vue-uuid';
  // 所有接口
  import actions from '@/actions/index'
  import { mapState, mapMutations } from 'vuex'
  import { dataURLtoBlob, blobToFile } from '@/utils/utils'
  import MessageBox from '@/components/block/MessageBox'

  export default {
    name: 'companyRightContent4',
    props: {},
    data() {
      return {
        company_data:{
          products:[],
        },
        product:{
          "pro_name": "",//产品名称
          "pro_description": "", //产品描述
          "pro_logo": "" //产品logo
        },
        errorTips:{ //错误提示
          pro_name:'',
          pro_description:'',
          pro_logo:'', 
        },
        MessageBoxState:false,//是否显示删除框
        MessageBoxData:{
          title:'温馨提示',
          desc:'确定删除这个产品介绍吗？'
        },
        addProductState:false, //添加弹窗
        productIndex:-1, //编辑的第几个
        saveFormState:false, //是否正在保存
        logoUrl:'https://logo.wondercv.com',//logo域名
      }
    },
    components:{
      MessageBox,
    },
    created() {
      // this.logoUrl = process.env.VUE_APP_ENV_TYPE === 'prod' ? 'https://logo.wondercv.com' : 'https://logo.wondercv.cn';
    },
    computed: {
      ...mapState('block', ['ossOptions']),
      ...mapState('company', ['companyData', 'companyTabIndex']),
    },
    methods: {
      ...mapMutations('company',['updateCompanyData','updateCompanyTabIndex']),
      //【删除】执行确认
      confirmButton(){
        let { id } = this.company_data.products[this.productIndex];
        actions.company.delete_company_products(id).then(res=>{
          if(res.code === 1000){
            //删除
            this.company_data.products.splice(this.productIndex, 1);
            this.$message.success('产品介绍删除成功');
            this.MessageBoxState = false;
          }else{
            this.$message({
              message:res.message,
              type:'error'
            })
          }
        })
      },
      //【删除】执行取消
      cancelButton(){
        this.MessageBoxState = false;
      },
      //添加产品
      addProduct(){
        if(this.company_data.products.length>=6){
          this.$message.success('最多可添加6个产品介绍');
          return false;
        }
        this.productIndex = -1;
        this.product = {
          company_id:this.companyData.token,
          "pro_name": "",//产品名称
          "pro_description": "", //产品描述
          "pro_logo": "" //产品logo
        }
        this.errorTips = { //错误提示
          pro_name:'',
          pro_description:'',
          pro_logo:'', 
        }
        //添加弹窗
        this.toggleEditProductState(true);
      },
      //修改产品
      editProduct(item,index){
        this.product = JSON.parse(JSON.stringify(item))
        this.productIndex = index;
        this.errorTips = { //错误提示
          pro_name:'',
          pro_description:'',
          pro_logo:'', 
        }
       //添加弹窗
        this.toggleEditProductState(true);
      },
      //上传之前验证
      beforeFileUpload(file) {
        const fileTypes = 'image/png,image/gif,image/jpeg,image/tif,image/tiff,image/bmp,image/x-bmp'
        const isJPG = fileTypes.indexOf(file.type)>-1;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传产品logo格式错误!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传产品logo大小不能超过 2MB!');
          return false;
        }
        return true;
      },
      //图片上传
      fileUpload(e){
        // 获取图片base64
        let file = this.$refs.fileUpload.files[0]
        if(!this.beforeFileUpload(file)){
          this.$refs.fileUpload.value = '';
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e =>{
          const store = oss(this.ossOptions);
          let imgName = `${uuid.v1()}.${file.type.split('/')[1]}`
          //调用
          var blob = dataURLtoBlob(e.currentTarget.result);
          var fileData = blobToFile(blob, imgName);
          let downloadLoading =  this.$message({
            message: '正在上传',
            iconClass:'el-icon-loading',
            duration:0,
          });
          store.put(`products/${imgName}`, fileData).then((res) => {
            downloadLoading.close();
            if(res.res.statusCode===200){
              this.product.pro_logo = `${this.logoUrl}/${res.name}`
              this.$refs.fileUpload.value = '';
              this.$message({
                message: '上传成功',
                type: 'success'
              });
            }else{
              this.$message({
                message: '图片上传失败',
                type: 'error'
              });
            }
          });
        }
      },
      //取消错误提示
      inputFocus(type){
        this.errorTips[type] = ''
      },
      //【保存】保存
      saveProduct(){
        let { pro_name, pro_description, pro_logo,} = this.product;
        let formState = true;
        if(!pro_logo){
          this.errorTips.pro_logo = '请上传产品logo';
          formState = false;
        }
        if(!pro_name){
          this.errorTips.pro_name = '请填写产品名称';
          formState = false;
        }
        if(!pro_description){
          this.errorTips.pro_description = '请填写产品描述';
          formState = false;
        }
        if(!formState){
          return false;
        }
        if(this.saveFormState){
          return false;
        }
        this.saveFormState = true;
        //执行保存/添加
        if(this.product.id){
          this.PutProduct();
        }else{
          this.PostProduct();
        }
      },
      //添加产品
      PostProduct(){
        actions.company.add_company_products(this.product).then(res=>{
          this.saveFormState = false;
          if(res.code === 1000){
            let { id } = res.data;
            let { products } = this.company_data;
            let companyData = JSON.parse(JSON.stringify(this.companyData));
            this.product.id = id;
            products.push(this.product);
            companyData.products = products;
            //添加弹窗
            this.toggleEditProductState(false);
            //同步数据到vuex
            this.updateCompanyData(companyData)
            this.$message.success('产品介绍添加成功');
          }else{
            this.$message({
              message:res.message,
              type:'error'
            })
          }
        })
      },
      //修改产品
      PutProduct(){
        actions.company.put_company_products(this.product).then(res=>{
          this.saveFormState = false;
          if(res.code === 1000){
            let { products } = this.company_data;
            let companyData = JSON.parse(JSON.stringify(this.companyData));
            products[this.productIndex] = this.product;
            companyData.products = products;
            this.company_data.products = products;
            //关闭弹窗
            this.toggleEditProductState(false);
            //同步数据到vuex
            this.updateCompanyData(companyData)
            this.$message.success('产品介绍修改成功');
          }else{
            this.$message({
              message:res.message,
              type:'error'
            })
          }
        })
      },
      //切换修改产品弹窗状态
      toggleEditProductState(state){
        this.addProductState = state;
        if(state){
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }else{
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }
      }
    },
    watch:{
      companyData :{
        handler: function (val, oldVal) {
          this.company_data = JSON.parse(JSON.stringify(val));
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './rightContent.scss';
</style>